import React from 'react';
import { useLocation } from 'react-use';

import { CustomLink } from '../../components';
import { RoutePath } from '../../constants';
import { BAYMAX_LINKS, copyrightYearValue, LINKS } from './constants';
import { FooterContentLeft, FooterContentRight, FooterCopyrightYear, FooterWrapper } from './styled';

type Props = {
  isBaymax?: boolean;
};

const Footer = ({ isBaymax }: Props): JSX.Element => {
  const { pathname } = useLocation();

  if (pathname === RoutePath.LOGOUT) {
    return <></>;
  }

  return (
    <FooterWrapper data-testid="footerWrapper" $isBaymax={isBaymax}>
      <FooterContentRight>
        <FooterCopyrightYear>
          {copyrightYearValue}
          {'Disney Advertising Sales, LLC'}
        </FooterCopyrightYear>
        {!isBaymax && <CustomLink link={LINKS.terms} text="Disney Campaign Manager Terms" />}
        {isBaymax && <CustomLink link={BAYMAX_LINKS.portalTerms} text="Disney Client Reporting Portal Terms" />}
        {isBaymax && <CustomLink link={BAYMAX_LINKS.terms} text="Disney Campaign Manager Terms" />}
        <CustomLink link={LINKS.privacyPolicy} text="Updated Privacy Policy" />
      </FooterContentRight>
      <FooterContentLeft />
    </FooterWrapper>
  );
};

export default Footer;
